import apiSlice from '@/api/apiSlice'

interface UserInfo {
  needVerify: boolean;
  contractDeadline?: string;
  showIncome: boolean; // 是否显示收入
  isMigrated: boolean; // 是否迁移
  uid: string;
}

const accountSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getUserInfo: build.query<UserInfo, void>({
      query: () => {
        return {
          url: '/account/v1/info',
        }
      },
      transformResponse: (response: UserInfo) => {
        return { ...response }
      },
    }),
  }),
})

export const { useGetUserInfoQuery } = accountSlice
